import { VideoCardProps } from "@fdr/atomic-ui/_molecules/VideoCard";

export interface JWPlayerAPISources {
  file: string;
  type: string;
  height: number;
  width: number;
}

export interface JWPlayerAPITracks {
  file: string;
  type: string;
  label: string;
}

export interface JWPlayerAPIVideo {
  category: string;
  duration: number;
  mediaid: string;
  image: string;
  videoTitle: string;
  sources: JWPlayerAPISources[];
  trakcs: JWPlayerAPITracks[];
}

export interface JWPlayerAPIResponse {
  playlist: JWPlayerAPIVideo[];
}

export interface DefaultPlaylistSettings {
  playlistUrl: string;
  playerScript: string;
  licenseKey: string;
}

export enum VideoNativeRotation {
  PORTRAIT,
  LANDSCAPE,
  ALL
}

export interface JWPlayerProgramPageResponse {
  raceDate?: Date;
  raceId?: string;
  title?: string;
  playlist: VideoCardProps[];
}
